export default __webpack_public_path__ + "static/media/KOD0110-min.1a99769b.webp";